export const IS_IMAGE = ["gif", "png", "jpg", "jpeg", "bmp"];
export const IS_AUDIO = ["mp3"];
